<template>
  <div class="page">
    <div class="locations-grey locations-generic used">
      17 foot aluminum canoes starting at $300. For details, email: <a href="Jeff@ChicagoRiverPaddle.com">Jeff@ChicagoRiverPaddle.com</a>
  </div>
  </div>
</template>

<script>
export default {
  name: 'used',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.links {
 width: 80%;
}
@media screen and (max-width: 768px) {
  .links {
    width: 90%;
  }
}
.page {
  background-image: url("../../assets/pic4.png");
  flex-direction: column;
  padding-left: 20px;
  align-items: center;
}
section {
  margin-bottom: 10px;
}
a:hover {
  color: #c0504d;
}
a {
  color: White; 
}
</style>
